class PdGiftItems extends HTMLElement {
  connectedCallback() {
    const min = new Date();
    min.setDate(min.getDate() + 2);
    const minStr = min.toISOString().split('T')[0];
    this.querySelectorAll('[data-gift-date]').forEach((input) => {
      input.min = minStr;
    });

    this.addEventListener('change', (e) => {
      if (e.target.matches('.pd-gift-item__checkbox')) {
        const item = e.target.closest('.pd-gift-item');
        const form = item.querySelector('.pd-gift-item__form');
        if (form) form.hidden = !e.target.checked;
      }
    });

    this.addEventListener('click', (e) => {
      const btn = e.target.closest('.pd-gift-item__checkout-btn');
      if (btn) {
        e.preventDefault();
        this.checkoutGift(btn.closest('.pd-gift-item'));
        return;
      }

      const backBtn = e.target.closest('.pd-gift-item__back');
      if (backBtn) {
        e.preventDefault();
        const item = backBtn.closest('.pd-gift-item');
        const checkbox = item.querySelector('.pd-gift-item__checkbox');
        const form = item.querySelector('.pd-gift-item__form');
        if (checkbox) checkbox.checked = false;
        if (form) form.hidden = true;
      }
    });

    this.restoreIntent();
  }

  restoreIntent() {
    let variantId;
    try {
      variantId = localStorage.getItem('pd_gift_intent_variant');
    } catch (e) {
      return;
    }
    if (!variantId) return;
    const item = this.querySelector('.pd-gift-item[data-variant-id="' + variantId + '"]');
    if (item) {
      const checkbox = item.querySelector('.pd-gift-item__checkbox');
      const form = item.querySelector('.pd-gift-item__form');
      if (checkbox) checkbox.checked = true;
      if (form) form.hidden = false;
      item.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    try {
      localStorage.removeItem('pd_gift_intent_variant');
    } catch (e) {}
  }

  async checkoutGift(itemEl) {
    const status = itemEl.querySelector('.pd-gift-item__status');
    const setStatus = (text, isError) => {
      if (!status) return;
      status.textContent = text;
      status.classList.toggle('pd-gift-status--error', !!isError);
    };

    const lineKey = itemEl.dataset.lineKey;
    const variantId = itemEl.dataset.variantId;
    const quantity = itemEl.dataset.quantity || '1';

    const getVal = (name) => {
      const field = itemEl.querySelector('[name="' + name + '"]');
      return field ? field.value.trim() : '';
    };
    const getChecked = (name) => {
      const field = itemEl.querySelector('[name="' + name + '"]');
      return field ? field.checked : false;
    };

    const whatsapp = getVal('buyer_whatsapp');
    const receiverPhone = getVal('receiver_phone');
    const recipientName = getVal('recipient_name');
    const cardVariantId = getVal('card_variant_id');
    const wantsWrap = getChecked('wants_wrap');
    const wantsDelivery = getChecked('wants_delivery');
    const message = getVal('personal_message');
    const deliveryDate = getVal('delivery_date');

    if (!whatsapp || !receiverPhone) {
      setStatus("Please add your WhatsApp number and the receiver's contact number.", true);
      return;
    }

    setStatus('Preparing your gift checkout…', false);

    const wrapVariantId = this.dataset.wrapVariantId;
    const deliveryVariantId = this.dataset.deliveryVariantId;

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 }),
      });

      const parts = [variantId + ':' + quantity];
      if (cardVariantId) parts.push(cardVariantId + ':1');
      if (wantsWrap && wrapVariantId) parts.push(wrapVariantId + ':1');
      if (wantsDelivery && deliveryVariantId) parts.push(deliveryVariantId + ':1');

      const noteLines = ['GIFT ORDER', 'Buyer WhatsApp: ' + whatsapp, 'Receiver contact (Malta): ' + receiverPhone];
      if (recipientName) noteLines.push('Recipient name: ' + recipientName);
      if (deliveryDate) {
        noteLines.push(
          'Requested delivery date: ' + deliveryDate + ' (not guaranteed — may shift due to unforeseen circumstances)'
        );
      }
      if (message) noteLines.push('Message: ' + message);
      const note = noteLines.join('\n');

      window.location.href = '/cart/' + parts.join(',') + '/checkout?note=' + encodeURIComponent(note);
    } catch (err) {
      setStatus('Something went wrong — please try again.', true);
    }
  }
}

if (!customElements.get('pd-gift-items')) {
  customElements.define('pd-gift-items', PdGiftItems);
}
